import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputMultiSelect } from '@/components/Input/InputMultiSelect'

const bathroomOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
]

type Options = typeof bathroomOptions

type Props = {
  baths?: number[]
}

export const BathSelection: FC<Props> = ({ baths }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()
  const initialFilters: Options | undefined = baths
    ? baths.map((v) => {
        return { label: '' + v, value: '' + v }
      })
    : undefined

  const handleSubmit = (values: { baths?: Options }) => {
    if (values.baths) {
      if (values.baths.length > 0) {
        values.baths &&
          WorkspaceDispatch(WorkspaceAction.updateFilters({ baths: values.baths.map((v) => Number(v.value)) }))
      } else {
        values.baths && WorkspaceDispatch(WorkspaceAction.updateFilters({ baths: undefined }))
      }
    }
  }

  return (
    <Formik
      initialValues={{
        baths: initialFilters,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className=" flex w-1/2 flex-row flex-wrap">
            <InputMultiSelect
              className="w-full"
              id="baths"
              name="baths"
              onChange={submitForm}
              options={bathroomOptions}
              variant="clean"
            />
          </Form>
        )
      }}
    </Formik>
  )
}
